/* eslint-disable no-unused-expressions,no-unused-vars */
/* global PLATFORM, G */
import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { set, get } from 'lib/sequence/component/state/value'
import listTemperatureUnits from 'app/xEcoApm/event/collection/listTemperatureUnits'

/**
 * Maps project and customer data from the measurement model to the view, possibly set by the
 * {@link setProject} event handler.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const mapProject = module => async (components, ...args) => {
  const { measurement } = module[G.MODEL][G.CHILDREN]
  const { project, customer } = measurement[G.CHILDREN]
  const { project: projectField, customer: customerField } = components

  project[G.CACHE] && set(projectField, project[G.CACHE])
  customer[G.CACHE] && set(customerField, customer[G.CACHE])

  return [components, ...args]
}

/**
 * Sets the default value for the temperatureUnit field.
 *
 * @param module  current module
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const initTemperatureUnit = module => async (components, ...args) => {
  const { temperatureUnit } = components

  const [defaultTemperatureUnit] = listTemperatureUnits(module, components.component, null)
  !get(temperatureUnit) && set(temperatureUnit, defaultTemperatureUnit.key)

  return [components, ...args]
}

/**
 * Closes the pipe by only returning the `args` parameter.
 *
 * @param components  {@link find} proxy of the current action component
 * @param args        additional arguments
 * @returns {Promise<object>}
 */
const returnArgs = async (components, ...args) => args

/**
 * Measurement Detail Action
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  mapProject(module),
  initTemperatureUnit(module),
  returnArgs,
)(find(component), ...args)
